import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyA3Gp9NDe-zCyF5aurdsgVtYqbQF-Xuqds",
    authDomain: "chat-e4e5e.firebaseapp.com",
    databaseURL: "https://chat-e4e5e-default-rtdb.firebaseio.com"
};
firebase.initializeApp(config);
export const auth = firebase.auth;
export const db = firebase.database();
